export default "__VITE_ASSET__DZq8XjPD__"